import { useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router"
import { useUser } from "@/apis/bff"
import { canUserTakeAppointmentWithService } from "@/lib/can-user-take-appointment-with-service"
import { useContextAppointment } from "@/modules/patients/hooks/useContextAppointment"

export const useHandleAppointmentParam = () => {
  const navigate = useNavigate()

  const [searchParams] = useSearchParams()
  const contextAppointment = useContextAppointment()
  const user = useUser()

  useEffect(() => {
    if (!contextAppointment) {
      return
    }
    const isCancelled = contextAppointment.status === "CANCELLED"
    if (!canUserTakeAppointmentWithService(user, contextAppointment.service) || isCancelled) {
      searchParams.delete("appointmentId")
      navigate({ search: searchParams.toString() }, { replace: true })
    }
  }, [navigate, contextAppointment, user, searchParams])
}
